<template>
  <div class="container-fluid hero-carousel">
    <div class="row">
      <div class="col-12 col-md-4 offset-md-1 mb-5">
        <vue-slick-carousel v-bind="settings">
          <div class="hero-item" v-for="(hero, index) in hero" :key="index">
            <img :src="hero.src" />
          </div>
        </vue-slick-carousel>
      </div>
      <div class="col-12 col-md-6 offset-md-1 mb-5">
        <div class="hero-text">
          <h1>
            FREE-TO-PLAY+<br />
            PLAY-AND-EARN!
          </h1>
          <p>
            ValhallaVerse is not built only for those <br />
            who are able to buy/rent an NFT.
          </p>
          <p>
            The players without enough funds to invest or<br />
            gamers just entering the NFT universe <br />
            will also have a chance to be a part of <br />
            ValhallaVerse ecosystem.
          </p>
          <p>
            Casual Arena is entirely Free-to-Play <br />
            for anyone who wants to explore <br />
            ValhallaVerse gaming experience!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  data() {
    return {
      settings: {
        dots: false,
        infinite: true,
        initialSlide: 0,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: false,
      },
      hero: [
        { src: "/assets/images/hero/1.webp" },
        { src: "/assets/images/hero/3.webp" },
      ],
    };
  },
  mounted() {
    //
  },
  components: {
    VueSlickCarousel,
  },
};
</script>

<style lang="scss" scoped>
.hero-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  text-shadow: 0 0 20px #fff4;
  color: #000;
  h1 {
    font-family: "Loki";
    text-transform: uppercase;
    margin-bottom: 2rem;
  }
  p {
    font-size: 1.2rem;
  }
  @media (max-width: 767.98px) {
    color: white;
    h1 {
      font-size: 2rem;
      color: #ffeec2;
    }
    p {
      font-size: 1rem;
    }
  }
}
.hero-carousel {
  margin-top: 7rem;
  margin-bottom: 2rem;
  @media (max-width: 576px) {
    margin-top: 4rem;
  }
  .slick-slider {
    width: 100%;
  }
  .hero-item {
    height: 40rem;
    @media (max-width: 576px) {
      height: 25rem;
    }
    @media (min-width: 1200px) and (max-width: 1440px) {
      height: 36rem;
    }
    @media (min-width: 1440.02px) and (max-width: 1600px) {
      height: 32rem;
    }
    @media (min-width: 1600.02px) and (max-width: 1920px) {
      height: 38rem;
    }
    @media (min-width: 1920.02px) {
      height: 50rem;
    }
    display: inline-block;
    position: relative;
    z-index: 1;
    img {
      max-width: 100%;
      height: 100%;
      margin: auto;
    }
  }
}
</style>
